import Text from 'components/Text/Text';
import React, { useContext, useMemo } from 'react';
import { IGameAssignmentContext, GameAssignmentContext } from '../../../../gameAssignmentState/gameAssignmentContext';
import Game from './components/Game';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import classNames from 'classnames';
import style from './Games.module.scss';

const Games: React.FC = () => {
	const { setIDsSelectedRestaurants, IDsSelectedRestaurants, searchStringForGames, games } =
		useContext<IGameAssignmentContext>(GameAssignmentContext);

	const filteredGames = useMemo(() => {
		if (searchStringForGames) {
			const updatedGames = games.map((el) => {
				const filteredGamesByName = el.games.filter((game) =>
					game.gameName?.toLowerCase().includes(searchStringForGames.toLowerCase()),
				);
				return { ...el, games: filteredGamesByName };
			});
			return updatedGames;
		}
		return games;
	}, [searchStringForGames, games]);

	const changeCloseStatus = (restaurantID: string) => {
		const copyIDsSelectedRestaurants = { ...IDsSelectedRestaurants };
		copyIDsSelectedRestaurants[restaurantID] = !copyIDsSelectedRestaurants[restaurantID];
		setIDsSelectedRestaurants(copyIDsSelectedRestaurants, false);
	};

	const deleteRestaurant = (restaurantID: string) => {
		const copyIDsSelectedRestaurants = { ...IDsSelectedRestaurants };
		delete copyIDsSelectedRestaurants[restaurantID];
		setIDsSelectedRestaurants(copyIDsSelectedRestaurants, true);
	};

	return (
		<div data-test="Games">
			{filteredGames.map((el) => {
				const wrapperClasses = classNames(style.wrapper, {
					[style.collapsedWrapper]: !IDsSelectedRestaurants[el.restaurantId],
				});

				return (
					<div key={el.restaurantId + 'mainDisplayGamesTab'}>
						<div className={wrapperClasses}>
							<div className={style.category}>
								<div className={style.name} onClick={() => changeCloseStatus(el.restaurantId)}>
									<Text
										translationKey={el.restaurantAddress}
										theme={!IDsSelectedRestaurants[el.restaurantId] ? 'secondary' : 'contrast'}
										withTooltip={true}
									/>
									<svg className={style.pointerIcon}>
										<use xlinkHref={`${breadcrumbs}#next`} />
									</svg>
								</div>
								<svg className={style.closeIcon} onClick={() => deleteRestaurant(el.restaurantId)}>
									<use xlinkHref={`${breadcrumbs}#close`} />
								</svg>
							</div>
							<div className={style.subcategory}>
								{el.games.length ? (
									<Game data={el.games} restaurantID={el.restaurantId} />
								) : (
									<Text
										translationNameSpace="listing"
										translationKey="noGamesLabel"
										theme="errorDark"
										weight="bold"
										align="center"
									/>
								)}
							</div>
						</div>
					</div>
				);
			})}
		</div>
	);
};

export default Games;
